import React from "react"
import ByDate from "./views/Review/ByDate";
import Trimester from "./views/Review/Trimester";
import RoomNights from "./views/Review/RoomNights";
import Adr from "./views/Review/Adr";
import Revenue from "./views/Review/Revenue";
import RevPar from "./views/Review/RevPar";
import Segment from "./views/Review/Segment";
import Channel from "./views/Review/Channel";

import ByDatePickup from "./views/Pickup/ByDate";
import OccupancyPickup from "./views/Pickup/OccupancyPickup";
import PacePickup from "./views/Pickup/PacePickup";
import TotalPickup from "./views/Pickup/TotalPickup";
import CxlPickup from "./views/Pickup/CxlPickup";
import NetPickup from "./views/Pickup/NetPickup";
import SegmentPickup from "./views/Pickup/Segment";
import ChannelPickup from "./views/Pickup/Channel";
import { production_chart } from "./widgets/Charts";
import ReactEcharts from "echarts-for-react";
import { latest as API_URL } from "../../../config/api";

import { isActiveSlide, positionLeft } from "../../../config/Helpers";
export const api = { baseUrl : API_URL + "dynamic-request" };

class Layout extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            active_slide : { key : "summary", index : 0 }, 
            touch_values : {
                start : 0,
                end: 0
            },
            slides : {
                0 : {
                    key: "summary", index: 0
                },
                1: {
                    key: "pickup", index: 1
                }
            },
            min_slide : 1,
            max_slide : 2, 
            statics : [],
            chart_pickup : {},
            statics_segments : [],
            statics_channels : [],
            statics_trimester : [],
            statics_aux : [],
            statics_segments_aux : [],
            statics_channels_aux : [],
            total_widgets : [],
            total_widgets_channels : [],
            filters_segment : [],
            filters_channels : [],
            filters_channels_aux : [],
            hidden_wdg_time : "show-widget complete",
            hidden_wdg_room_nights : "show-widget complete",
            hidden_wdg_adr : "show-widget complete",
            hidden_wdg_revenue : "show-widget complete",
            hidden_wdg_revpar : "show-widget complete",
            hide_widget_trimester : "hide-widget",
            key_filter_channel : null,
            filter_ms_active : "inactive",
            filter_month_active : "inactive",
            filter_trimester_active : "inactive",
            filter_segment_active : "inactive",
            request_status : "",
            key_trimester : "",
            active_chart_type : { key : "Día", value : "by_day"},
            tab_submodule : 'inactive',
            tab_filters : 'inactive'
        }
        this.setSegments = this.setSegments.bind(this);
        this.getChannels = this.getChannels.bind(this);
        this.activeFiltersMS = this.activeFiltersMS.bind(this);
        this.activeMonth = this.activeMonth.bind(this);
        this.activeSegment = this.activeSegment.bind(this);
        this.setTrimesters = this.setTrimesters.bind(this)
        this.activeWidget = this.activeWidget.bind(this);
        this.getDefaultValues = this.getDefaultValues.bind(this);
        this.setDefaultValuesModule = this.setDefaultValuesModule.bind(this);
        this.callMainRequest = this.callMainRequest.bind(this);
    }
    setDefaultValuesModule(update = false){
        let self = this;
        if(this.state.active_slide.key === "pickup"){
            self._widgetByDatePickup.setState(self._widgetByDatePickup.getDefaultValues());
            self._widgetSegmentPickup.setState(self._widgetSegmentPickup.getDefaultValues());
            if(update){
                self.setState(self.getDefaultValues(), () => this.callMainRequest(true));
            }else{
                self.setState(self.getDefaultValues(), () => this.callMainRequest());
            }
        }else{
            self._widgetByDate.setState(self._widgetByDate.getDefaultValues());
            self._widgetSegment.setState(self._widgetSegment.getDefaultValues());
            self._widgetTrimester.setState(self._widgetTrimester.getDefaultValues());
            self.setState(self.getDefaultValues(), () => this.callMainRequest());
        }
    }
    callMainRequest(pickup = false){
        if(pickup){
            this.props.app._widgetFiltersTime.setRangeCustom("pickup")
        }else{
            this.props.app.mainRequest()
        }
    }
    getOptionTypeBar = (chart) => {
        let self = this;
        if(Object.keys(this.state.chart_pickup).length > 0){
            let response = this.state.chart_pickup[self.state.active_chart_type.value];
            let option = production_chart(response);
            option["tooltip"] = {
                position: 'inside',
                triggerOn : 'click',
                alwaysShowContent : false,
                transitionDuration : 0,
                formatter: function (params, ticket, callback) {
    
                    /*axios.get(api.baseUrl, {
                        params : self.props.app.currentFilters() 
                    }).then(result => {
                        callback(ticket, "holaaa")
                    }).catch(error => { throw error; })
    
                    return "Cargando";*/
                }
            }
            return option;
        }else{
            return {}
        }
    }
    getDefaultValues(){
        return {
            touch_values : {
                start : 0,
                end: 0
            },
            slides : {
                0 : {
                    key: "summary", index: 0
                },
                1: {
                    key: "pickup", index: 1
                }
            },
            min_slide : 1,
            max_slide : 2, 
            statics: [],
            statics_segments: [],
            statics_channels: [],
            statics_trimester: [],
            statics_aux: [],
            statics_segments_aux: [],
            statics_channels_aux: [],
            total_widgets: [],
            total_widgets_channels: [],
            filters_segment: [],
            filters_channels: [],
            filters_channels_aux: [],
            hidden_wdg_time: "show-widget complete",
            hidden_wdg_room_nights: "show-widget complete",
            hidden_wdg_adr: "show-widget complete",
            hidden_wdg_revenue: "show-widget complete",
            hidden_wdg_revpar: "show-widget complete",
            hide_widget_trimester: "hide-widget",
            key_filter_channel: null,
            filter_ms_active: "inactive",
            filter_month_active: "inactive",
            filter_trimester_active: "inactive",
            filter_segment_active: "inactive",
            request_status: "",
            key_trimester: "",
            active_chart_type : { key : "Día", value : "by_day"},
            tab_submodule : 'inactive',
            tab_filters : 'inactive'
        }
    }
    setTrimesters(status, key, key_time, filt) {
        let active_trimester;
        let self = this;
        if (self.state.statics[filt].state === "active") {
            active_trimester = "inactive";
            self.state.statics[filt].state = "inactive";

            Object.keys(self.state.statics_trimester).map(function (key) {
                self.state.statics_trimester[key].state = "inactive";
            })
            self._widgetSegment.setState({
                segmentActive: {}
            });
            self.setState({
                filter_segment_active: active_trimester,
                filter_month_active: active_trimester,
                filter_trimester_active: active_trimester,
                hide_widget_trimester: "hide-widget",
                filters_segment: [],
                segments: [],
                statics_channels: [],
                statics: self.state.statics_aux,
                statics_segments: [],
                total_widgets_channels: [],
                key_time: null,
                key_filter_channel: null,
                key_trimester : ""
            }, ()  => {
                self.props.app.mainRequest()
            })
        } else {
            self.state.statics[filt].state = "active";
            self.setState({
                hide_widget_trimester: "",
                filters_segment: [],
                segments: [],
                key_trimester : key
            }, () => {
                self._widgetTrimester.setState({
                    status_widget: "inactive",
                    current_key_time: ""
                }, () => {
                    self.props.app.mainRequest()
                });
            })
        }
    }
    setSegments(segments, key_time, filt) {
        let self = this;
        if (self.state.key_trimester !== ""){
            const state_trimester = self.state.statics_trimester[filt].state === "active" ? "inactive" : "active";
            self.state.statics_trimester[filt].state = state_trimester;
            self.setState({
                filter_trimester_active: state_trimester
            })
        }
        
        const status  =  (Object.keys(filt).length > 0) ? "active" : "inactive";
        if (segments !== null) {
            self.setState({
                filters_segment: segments,
                filter_month_active: status,
                key_time: filt
            }, function () {
                self.props.app.mainRequest();
            })
        } else {

            //self._widgetSegment.state.segmentActive = {};
            self.setState({
                filters_segment: [],
                segments: [],
                filter_month_active: status,
                filter_segment_active: "inactive",
                statics_channels: {},
                segmentActive : {}
            }, function(){
                if(this.state.active_slide.key === "summary"){
                    self._widgetSegment.setState({
                        segmentActive : {}
                    }, function(){
                        self.props.app.mainRequest();
                    })
                }else{
                    self._widgetSegmentPickup.setState({
                        segmentActive : {}
                    }, function(){
                        self.props.app.mainRequest();
                    })
                }
            })
        }
    }
    activeSubmoduleTab() {
        this.setState(function(){
            const state = (this.state.tab_submodule === 'active') ? 'inactive' : 'active';
            return { 
                tab_submodule : state,
                tab_filters : 'inactive'
             }
        })
    }
    activeFiltersTab() {
        this.setState(function(){
            const state = (this.state.tab_filters === 'active') ? 'inactive' : 'active';
            return { 
                tab_submodule : 'inactive',
                tab_filters : state
             }
        })
    }
    getChannels(status, segmentActive) {
        let self = this;
        if (status === 'active') {
            self.setState({
                statics_channels: Object.assign({}, self.state.filters_channels),
                filter_segment_active : "active",
                segmentActive : segmentActive
            }, function(){
                setTimeout(() => {
                    this.forceUpdate();
                }, 100);
                
            })
        } else {
            self.setState({
                statics_channels : {},
                filter_segment_active : "inactive",
                segmentActive : {}

            }, function(){
                setTimeout(() => {
                    this.forceUpdate();
                }, 100);
            })
        }
    }

    activeFiltersMS(status) {
        this.setState({ filter_ms_active: status })
    }
    activeMonth(status, filt) {
    }
    activeSegment(status) {
        if (status === "inactive") {
            this.setState({
                filters_channels: [],
                statics_channels: []
            });
        }
        this.setState({
            filter_segment_active: status
        })
    }
    activeWidget(type) {
        let status;
        let self = this;
        this.setState(function (prevState) {

            if (type === "time") {
                status = { hidden_wdg_time: prevState.hidden_wdg_time === "hide-widget complete" ? "show-widget" : "hide-widget" }
            } else if (type === "room-nights") {
                status = { hidden_wdg_room_nights: prevState.hidden_wdg_room_nights === "hide-widget complete" ? "show-widget" : "hide-widget" }
            } else if (type === "adr") {
                status = { hidden_wdg_adr: prevState.hidden_wdg_adr === "hide-widget complete" ? "show-widget" : "hide-widget" }
            } else if (type === "revenue") {
                status = { hidden_wdg_revenue: prevState.hidden_wdg_revenue === "hide-widget complete" ? "show-widget" : "hide-widget" }
            }else if (type === "revpar") {
                status = { hidden_wdg_revpar: prevState.hidden_wdg_revpar === "hide-widget complete" ? "show-widget" : "hide-widget" }
            }
            return status;
        })
        setTimeout(() => {
            if (type === "time") {
                self.setState({
                    hidden_wdg_time: self.state.hidden_wdg_time === "hide-widget" ? "hide-widget complete" : "show-widget complete"
                });
            } else if (type === "room-nights") {
                self.setState({
                    hidden_wdg_room_nights: self.state.hidden_wdg_room_nights === "hide-widget" ? "hide-widget complete" : "show-widget complete"
                });
            } else if (type === "adr") {
                self.setState({
                    hidden_wdg_adr: self.state.hidden_wdg_adr === "hide-widget" ? "hide-widget complete" : "show-widget complete"
                });
            } else if (type === "revenue") {
                self.setState({
                    hidden_wdg_revenue: self.state.hidden_wdg_revenue === "hide-widget" ? "hide-widget complete" : "show-widget complete"
                });
            }else if (type === "revpar") {
                self.setState({
                    hidden_wdg_revpar: self.state.hidden_wdg_revpar === "hide-widget" ? "hide-widget complete" : "show-widget complete"
                });
            }
        }, 200);
    }
    componentWillReceiveProps(props){
        let response = props.app.state.review_response_request
        let self = this;
        if(Object.keys(response).length > 0){
            self.setState(function (prevState) {                
                let results = {}
                if (self.state.filters_segment.length > 0) {
                    let filters_channels_aux = {};
                    Object.keys(response.month_widgets).map(function(key) {
                        let rr = response.month_widgets[key];
                        filters_channels_aux[key] = {}
                        Object.keys(rr).map(function(key_two) {
                            filters_channels_aux[key][key_two] = {};
                            if(key_two !== "totals"){
                                let rr2 = rr[key_two]["channels"]
                                Object.keys(rr2).map(function(key_three){
                                    filters_channels_aux[key][key_two][key_three] = rr2[key_three]
                                });
                            }else{
                                filters_channels_aux[key][key_two] = rr[key_two]
                            }
                        });
                    })

                    results = {
                        chart_pickup : response.chart_pickup,
                        filters_channels: filters_channels_aux,
                        statics_segments_aux: response.month_widgets,
                        statics_segments: response.month_widgets
                        //total_widgets: response.total_widgets
                    }
                } else {
                    if (self.state.key_trimester === "") {
                        results = {
                            chart_pickup : response.chart_pickup,
                            statics_channels: [],
                            statics_segments: [],
                            statics_trimester: [],
                            statics_aux: response.month_widgets,
                            statics: response.month_widgets,
                            total_widgets: response.total_widgets
                        }
                    } else {
                        results = {
                            chart_pickup : response.chart_pickup,
                            statics_channels: [],
                            statics_segments: [],
                            statics_trimester: response.month_widgets,
                            total_widgets: response.total_widgets
                        }
                    }
                }
                return results;
            }, function () {
                let filt;
                if(this.state.active_slide.key === "summary"){
                    filt = self._widgetByDate.state.current_key_time;
                }else{
                    filt = self._widgetByDatePickup.state.current_key_time;
                }
                let state_statics = Object.assign({}, self.state.statics);
            
                Object.keys(state_statics).map(function(key){
                    if(filt[key] !== undefined){
                        state_statics[key].state = "active";
                    }else{
                        state_statics[key].state = "inactive";
                    }
                })
                self.setState({
                    statics_aux : state_statics,
                    statics : state_statics,
                },function(){
                    if(Object.keys(self._widgetSegment.state.segmentActive).length > 0){
                        self.getChannels("active", self._widgetSegment.state.segmentActive)
                    }

                    if(Object.keys(self._widgetSegmentPickup.state.segmentActive).length > 0){
                        self.getChannels("active", self._widgetSegmentPickup.state.segmentActive)
                    }
                })
            })
        }
    }
    activeSlide(slide){
        this._widgetSegment.state.segmentActive = {}
        this._widgetSegmentPickup.state.segmentActive = {}
        this.setState({
            active_slide : slide,
            current_slide : slide.key,
            segmentActive : {}
        }, function(){
            if(this.state.active_slide.key === "pickup"){
                this.props.app.state.pickup = 1;
                this.setDefaultValuesModule(true);
            }else{
                this.props.app.state.pickup = 0;
                this.props.app.getInitialStatics('reset')
            }
        })
    }
    activeChartType(item){
        this.setState({
            active_chart_type : item
        }, function(){

        })
    }
    chartTypes(){
        let self = this;
        const types = [
            { key : "Mes", value : "by_month" },
            { key : "Semana", value : "by_week" },
            { key : "Día", value : "by_day" }
        ];
        
        let chart_types = types.map((item, index) => (
            <div className={"chart-type-select " + (item.value === self.state.active_chart_type.value ? "active" : "") } key={"list-chart-type-"+index} onClick={self.activeChartType.bind(self, item)}>
                <span children={item.key} />
            </div>
        ))
        return chart_types;
    }
    render() {
        return (
            <div className="layout">
                <div className={"loading-panel " + this.state.request_status + " " + (this.props.app.state.panel !== "review" ? "hide" : "")}>
                    <div className="bkg-stars">
                        <span className="figure-1"></span>
                    </div>
                </div>
                <div style={positionLeft(0, this.state.active_slide.index)} className={"slide " + isActiveSlide(this.state.active_slide.key, "summary", "main-slide")}>
                    <ByDate
                        statics={this.state.statics}
                        total_widgets={this.state.total_widgets}
                        activeFiltersMS={this.activeFiltersMS}
                        activeMonth={this.activeMonth}
                        activeSegment={this.activeSegment}
                        setSegments={this.setSegments}
                        filters_segment={this.state.filters_segment}
                        widgetSegment={this._widgetSegment}
                        getInitialStatics={this.props.app.getInitialStatics}
                        hidden_wdg_time={this.state.hidden_wdg_time}
                        activeWidget={this.activeWidget}
                        current_year={this.props.app.state.current_year}
                        past_year={this.props.app.state.past_year}
                        view_results={this.props.app.state.view_results}
                        setTrimesters={this.setTrimesters}
                        request_status={this.state.request_status}
                        layout={this}
                        ref={(child) => { this._widgetByDate = child; }}
                    />
                    <Trimester
                        statics={this.state.statics_trimester}
                        total_widgets={this.state.total_widgets}
                        activeFiltersMS={this.activeFiltersMS}
                        activeMonth={this.activeMonth}
                        activeSegment={this.activeSegment}
                        setSegments={this.setSegments}
                        getSegments={this.getSegments}
                        filters_segment={this.state.filters_segment}
                        filter_trimester_active={this.state.filter_trimester_active}
                        widgetSegment={this._widgetSegment}
                        getInitialStatics={this.props.app.getInitialStatics}
                        view_results={this.props.app.state.view_results}
                        activeWidget={this.activeWidget}
                        hidden_wdg_time={this.state.hidden_wdg_time}
                        hide_widget_trimester={this.state.hide_widget_trimester}
                        key_trimester={this.state.key_trimester}
                        request_status={this.state.request_status}
                        filter_by_pace={this.props.app.state.filter_by_pace}
                        ref={(child) => { this._widgetTrimester = child; }}
                    />
                    <div className={"container-aux " + this.state.filter_ms_active}>
                        <Segment
                            ref={(child) => { this._widgetSegment = child; }}
                            statics={this.state.statics}
                            filters_segment={this.state.filters_segment}
                            filter_month_active={this.state.filter_month_active}
                            getChannels={this.getChannels}
                            request_status={this.state.request_status}
                            activeSegment={this.activeSegment}
                            layout={this}
                            app={this.props.app}
                        />
                        <Channel
                            filter_segment_active={this.state.filter_segment_active}
                            statics={this.state.statics}
                            filters_channels={this.state.filters_channels}
                            current_filter_channel={this.props.app.state.current_filter_channel}
                            key_filter_channel={this.state.key_filter_channel}
                            skipFilterChannel={this.props.app.skipFilterChannel}
                            skip_channels={this.props.app.state.skip_channels}
                            request_status={this.state.request_status}
                            app={this.props.app}
                            layout={this}
                            ref={(child) => { this._widgetChannel = child; }}
                        />
                    </div>
                    <RoomNights
                        statics={this.state.statics}
                        statics_segments={this.state.statics_segments}
                        statics_channels={this.state.statics_channels}
                        statics_trimester={this.state.statics_trimester}
                        total_widgets={this.state.total_widgets}
                        total_widgets_channels={this.state.total_widgets_channels}
                        hidden_wdg_room_nights={this.state.hidden_wdg_room_nights}
                        request_status={this.state.request_status}
                        activeWidget={this.activeWidget}
                        filter_by_pace={this.props.app.state.filter_by_pace}
                        app={this.props.app}
                        layout={this}
                        ref={(child) => { this._widgetRoomNights = child; }}
                    />
                    <Adr
                        statics={this.state.statics}
                        statics_segments={this.state.statics_segments}
                        statics_channels={this.state.statics_channels}
                        statics_trimester={this.state.statics_trimester}
                        total_widgets={this.state.total_widgets}
                        total_widgets_channels={this.state.total_widgets_channels}
                        hidden_wdg_adr={this.state.hidden_wdg_adr}
                        request_status={this.state.request_status}
                        activeWidget={this.activeWidget}
                        filter_by_pace={this.props.app.state.filter_by_pace}
                        app={this.props.app}
                        layout={this}
                        ref={(child) => { this._widgetAdr = child; }}
                    />
                    <Revenue
                        statics={this.state.statics}
                        statics_segments={this.state.statics_segments}
                        statics_channels={this.state.statics_channels}
                        statics_trimester={this.state.statics_trimester}
                        total_widgets={this.state.total_widgets}
                        total_widgets_channels={this.state.total_widgets_channels}
                        hidden_wdg_revenue={this.state.hidden_wdg_revenue}
                        request_status={this.state.request_status}
                        activeWidget={this.activeWidget}
                        filter_by_pace={this.props.app.state.filter_by_pace}
                        app={this.props.app}
                        layout={this}
                        ref={(child) => { this._widgetRevenue = child; }}
                    />
                    <RevPar
                        app={this.props.app}
                        filter_by_pace={this.props.app.state.filter_by_pace}
                        layout={this}
                        ref={(child) => { this._widgetRevPar = child; }}
                    />
                    <div className={"hidden-widgets "}>
                        <span className={"wdg time " + (this.state.hidden_wdg_time !== "hide-widget complete" ? "hide-widget" : null)} onClick={this.activeWidget.bind(this,"time")}>
                            <div className="opt-w">
                                <span className="">PERIODO</span> <i className="fa fa-eye"></i>
                            </div>
                        </span>
                        <span className={"wdg room-nights " + (this.state.hidden_wdg_room_nights !== "hide-widget complete" ? "hide-widget" : null)} onClick={this.activeWidget.bind(this,"room-nights")}>
                            <div className="opt-w">
                                <span className="">CUARTOS NOCHE</span> <i className="fa fa-eye"></i>
                            </div>
                        </span>
                        <span className={"wdg adr " + (this.state.hidden_wdg_adr !== "hide-widget complete" ? "hide-widget" : null)} onClick={this.activeWidget.bind(this,"adr")}>
                            <div className="opt-w">
                                <span className="">TARIFA PROMEDIO</span> <i className="fa fa-eye"></i>
                            </div>
                        </span>
                        <span className={"wdg revenue " + (this.state.hidden_wdg_revenue !== "hide-widget complete" ? "hide-widget" : null)} onClick={this.activeWidget.bind(this,"revenue")}>
                            <div className="opt-w">
                                <span className="">INGRESOS</span> <i className="fa fa-eye"></i>
                            </div>
                        </span>
                        <span className={"wdg revpar " + (this.state.hidden_wdg_revpar !== "hide-widget complete" ? "hide-widget" : null)} onClick={this.activeWidget.bind(this,"revpar")}>
                            <div className="opt-w">
                                <span className="">REVPAR</span> <i className="fa fa-eye"></i>
                            </div>
                        </span>
                    </div>
                </div>
                <div style={positionLeft(1, this.state.active_slide.index)} className={"slide " + isActiveSlide(this.state.active_slide.key, "pickup", "main-slide")}>
                    <ByDatePickup
                        statics={this.state.statics}
                        total_widgets={this.state.total_widgets}
                        activeFiltersMS={this.activeFiltersMS}
                        activeMonth={this.activeMonth}
                        activeSegment={this.activeSegment}
                        setSegments={this.setSegments}
                        filters_segment={this.state.filters_segment}
                        widgetSegment={this._widgetSegment}
                        getInitialStatics={this.props.app.getInitialStatics}
                        hidden_wdg_time={this.state.hidden_wdg_time}
                        activeWidget={this.activeWidget}
                        current_year={this.props.app.state.current_year}
                        past_year={this.props.app.state.past_year}
                        view_results={this.props.app.state.view_results}
                        setTrimesters={this.setTrimesters}
                        request_status={this.state.request_status}
                        layout={this}
                        ref={(child) => { this._widgetByDatePickup = child; }}
                    />
                    <div className={"container-aux " + this.state.filter_ms_active}>
                        <SegmentPickup
                            ref={(child) => { this._widgetSegmentPickup = child; }}
                            statics={this.state.statics}
                            filters_segment={this.state.filters_segment}
                            filter_month_active={this.state.filter_month_active}
                            getChannels={this.getChannels}
                            request_status={this.state.request_status}
                            activeSegment={this.activeSegment}
                            layout={this}
                            app={this.props.app}
                        />
                        <ChannelPickup
                            filter_segment_active={this.state.filter_segment_active}
                            statics={this.state.statics}
                            filters_channels={this.state.filters_channels}
                            current_filter_channel={this.props.app.state.current_filter_channel}
                            key_filter_channel={this.state.key_filter_channel}
                            skipFilterChannel={this.props.app.skipFilterChannel}
                            skip_channels={this.props.app.state.skip_channels}
                            request_status={this.state.request_status}
                            app={this.props.app}
                            layout={this}
                            ref={(child) => { this._widgetChannelPickup = child; }}
                        />
                    </div>
                    <OccupancyPickup
                        current_year={this.props.app.state.current_year}
                        past_year={this.props.app.state.past_year}
                        statics={this.state.statics}
                        statics_segments={this.state.statics_segments}
                        statics_channels={this.state.statics_channels}
                        statics_trimester={this.state.statics_trimester}
                        total_widgets={this.state.total_widgets}
                        total_widgets_channels={this.state.total_widgets_channels}
                        hidden_wdg_room_nights={this.state.hidden_wdg_room_nights}
                        request_status={this.state.request_status}
                        activeWidget={this.activeWidget}
                        filter_by_pace={this.props.app.state.filter_by_pace}
                        app={this.props.app}
                        layout={this}
                        ref={(child) => { this._widgetOccupancyPickup = child; }}
                    />
                    <PacePickup
                        current_year={this.props.app.state.current_year}
                        past_year={this.props.app.state.past_year}
                        statics={this.state.statics}
                        statics_segments={this.state.statics_segments}
                        statics_channels={this.state.statics_channels}
                        statics_trimester={this.state.statics_trimester}
                        total_widgets={this.state.total_widgets}
                        total_widgets_channels={this.state.total_widgets_channels}
                        hidden_wdg_room_nights={this.state.hidden_wdg_room_nights}
                        request_status={this.state.request_status}
                        activeWidget={this.activeWidget}
                        filter_by_pace={this.props.app.state.filter_by_pace}
                        app={this.props.app}
                        layout={this}
                        ref={(child) => { this._widgetPacePickup = child; }}
                    />
                    <TotalPickup
                        current_year={this.props.app.state.current_year}
                        past_year={this.props.app.state.past_year}
                        statics={this.state.statics}
                        statics_segments={this.state.statics_segments}
                        statics_channels={this.state.statics_channels}
                        statics_trimester={this.state.statics_trimester}
                        total_widgets={this.state.total_widgets}
                        total_widgets_channels={this.state.total_widgets_channels}
                        hidden_wdg_room_nights={this.state.hidden_wdg_room_nights}
                        request_status={this.state.request_status}
                        activeWidget={this.activeWidget}
                        filter_by_pace={this.props.app.state.filter_by_pace}
                        app={this.props.app}
                        layout={this}
                        ref={(child) => { this._widgetTotalPickup = child; }}
                    />

                    <CxlPickup
                        current_year={this.props.app.state.current_year}
                        past_year={this.props.app.state.past_year}
                        statics={this.state.statics}
                        statics_segments={this.state.statics_segments}
                        statics_channels={this.state.statics_channels}
                        statics_trimester={this.state.statics_trimester}
                        total_widgets={this.state.total_widgets}
                        total_widgets_channels={this.state.total_widgets_channels}
                        hidden_wdg_room_nights={this.state.hidden_wdg_room_nights}
                        request_status={this.state.request_status}
                        activeWidget={this.activeWidget}
                        filter_by_pace={this.props.app.state.filter_by_pace}
                        app={this.props.app}
                        layout={this}
                        ref={(child) => { this._widgetCxlPickup = child; }}
                    />
                    <NetPickup
                        current_year={this.props.app.state.current_year}
                        past_year={this.props.app.state.past_year}
                        statics={this.state.statics}
                        statics_segments={this.state.statics_segments}
                        statics_channels={this.state.statics_channels}
                        statics_trimester={this.state.statics_trimester}
                        total_widgets={this.state.total_widgets}
                        total_widgets_channels={this.state.total_widgets_channels}
                        hidden_wdg_room_nights={this.state.hidden_wdg_room_nights}
                        request_status={this.state.request_status}
                        activeWidget={this.activeWidget}
                        filter_by_pace={this.props.app.state.filter_by_pace}
                        app={this.props.app}
                        layout={this}
                        ref={(child) => { this._widgetNetPickup = child; }}
                    />

                    <div className={"datagrid-widget chart-pickup  "}>
                        <div className="container-fluid">
                            <div className="row header-widget">
                                <div className="col-md-12 options-widget">
                                    <span className="title">PRODUCCIÓN</span>
                                    <div className="chart-types">
                                        {this.chartTypes()}
                                    </div>
                                </div>
                            </div>
                            <div className="current-values">
                                <div className="row">
                                    <div className="col-md-12 datagrid-list">
                                        <div className="group-years-query">
                                            <span> <span className="current-year" /> {this.props.app.state.past_year}</span>
                                            <span> <span className="last-year" /> {this.props.app.state.current_year}</span>
                                        </div>
                                        <ReactEcharts
                                            option={(this.props.app.state.panel === "review" && this.state.active_slide.key === "pickup") ? this.getOptionTypeBar("data_reserves_production") : {} }
                                            notMerge={true}
                                            lazyUpdate={true}
                                            theme={"theme_name"}
                                            
                                            onChartReady={this.onChartReadyCallback}
                                        />
                                    </div>
                                </div>
                            </div>   
                        </div>
                    </div>
                </div>
                <div className={"slide-keys " + (this.props.app.state.panel !== "review" ? "hide" : "")}>
                    <div className="tabs">
                        <div className={this.state.tab_submodule} onClick={this.activeSubmoduleTab.bind(this)}>SUBMODULOS</div>
                        <div className={this.state.tab_filters} onClick={this.activeFiltersTab.bind(this)}>FILTROS</div>
                    </div>
                    <div className={"content-filters " + this.state.tab_filters}>
                    </div>
                    <div className={"content-submodules " + this.state.tab_submodule}>
                        <div className={isActiveSlide(this.state.active_slide.key, "summary")} onClick={this.activeSlide.bind(this, {key : "summary", index : 0})}>
                            <span className="title">RESUMEN</span>
                        </div>
                        <div className={isActiveSlide(this.state.active_slide.key, "pickup")} onClick={this.activeSlide.bind(this, { key: "pickup", index : 1})}>
                            <span className="title">PICKUP</span>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Layout



// WEBPACK FOOTER //
// ./src/Frontend/modules/marketing/review/Layout.js